import { useContext } from 'react';
import { FeatureFlipContext } from '../context/featureFlipContext';
import PropTypes from 'prop-types';

const FeatureFlip = ({ feature, on, off }) => {
  const enabled = useContext(FeatureFlipContext)[feature];

  return enabled ? on : off;
};

FeatureFlip.propTypes = {
  feature: PropTypes.string.isRequired,
  on: PropTypes.node,
  off: PropTypes.node,
};

FeatureFlip.defaultProps = {
  off: null,
  on: null,
};

export default FeatureFlip;
